import { FunctionComponent, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { WrapWithStepperContext } from "../../../../components/stepper/context";
import { StepInfo } from "../../../../components/stepper/models";
import { VerticalLinearStepper } from "../../../../components/stepper/vertical";
import { CryptoDTO } from "../../../../store/crypto/models/dto";
import { Description } from "./description";
import { SocialMedia } from "./social-media";
import { Terms } from "./terms";
import { TransactionDetails } from "./transaction-details";
import { UploadDocs } from "./upload-docs";

const useSteps: () => Array<
  StepInfo & {
    content:
      | typeof Description
      | typeof TransactionDetails
      | typeof SocialMedia
      | typeof Terms
      | typeof UploadDocs;
  }
> = () => {
  const { t } = useTranslation("fields");

  return useMemo(
    () => [
      {
        title: t("report-a-scam"),
        content: Description,
      },
      {
        title: t("transaction-detail"),
        content: TransactionDetails,
      },
      {
        title: t("social-media"),
        content: SocialMedia,
      },
      {
        title: t("terms-and-conditions"),
        content: Terms,
      },
      {
        title: t("upload-evidence"),
        content: UploadDocs,
      },
    ],
    [t, Description, TransactionDetails, SocialMedia, Terms, UploadDocs]
  );
};

export const ReportAScamPage: FunctionComponent<{}> = () => {
  const [reportId, setReportId] = useState<
    CryptoDTO.Responses.GetSingleFraudReport.T["id"]
  >();

  const steps = useSteps();

  return (
    <WrapWithStepperContext>
      <VerticalLinearStepper
        steps={steps}
        stepsProps={useMemo(() => ({ reportId, setReportId }), [
          reportId,
          setReportId,
        ])}
      />
    </WrapWithStepperContext>
  );
};
